module.exports = __webpack_public_path__ + "img/Septris-sprite-bg.fa027baf.jpg";